
import BaseModel from './BaseModel';
import { getMomentDate } from '../utils/commonUtils';

export default class RateCode extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.campaign = data.campaign || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.code = data.code || undefined;
        this.cost = data.cost || 0;
        this.inventoryDeliveryType = data?.inventoryDeliveryType || undefined;
        this.adult = data?.adult || undefined;
        this.child = data?.child || undefined;
        this.room = data?.room || undefined;
        this.lengOfStay = data?.lengOfStay || undefined;
        this.rounding = data.rounding || 0;
        this.sellCost = data.sellCost || 0;
        this.description = data.description || this.translate.description || undefined;
        this.isActive = data.isActive || false;
        this.productTypes = data.productTypes || [];
        this.interestUnitType = data.interestUnitType || 1;
        this.surchargeCategory = data.surchargeCategory || undefined;
        this.RateCodeProducts(data);
        this.RateCodeSlotServices(data);
        this.stockAvailable = data.stockAvailable || 0;
     }

    RateCodeProducts(data = {}) {
        this.rateCodeProducts = (data.rateCodeProducts || []).map(item => new RateCodeProduct(item));
    }

    RateCodeSlotServices(data = {}) {
        this.slotServices = (data.slotServices || []).map(item => new RateCodeSlotService(item));
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            campaign: this.campaign,
            code: this.code,
            cost: this.cost,
            name: this.name,
            rounding: this.rounding,
            description: this.description,
            sellCost: this.sellCost,
            isActive: this.isActive,
            productTypes: this.productTypes,
            interestUnitType: this.interestUnitType || 1,
            surchargeCategory: this.surchargeCategory
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                name: this.translate.name || this.name,
                description: this.description,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}

export class RateCodeProduct extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
        this.code = data.code || undefined;
        this.cost = data.cost || 0;
        this.inventoryDeliveryType = data?.inventoryDeliveryType ?? undefined;
        this.sellCost = data.sellCost || 0;
        this.coefficient = data.coefficient || 1;
        this.interest = data.interest || 0;
        this.supplierProductId = data.supplierProductId || undefined;
        this.supplierCategoryCode = data.supplierCategoryCode || undefined;
        this.stockAvailable = data.stockAvailable;

        this.isRequired = data.isRequired || false;
        this.isAddNew = data.isAddNew || false;
    }

    export() {
        const result = {
            id: this.id,
            name: this.name,
            code: this.code,
            cost: this.cost,
            inventoryDeliveryType: this.inventoryDeliveryType,
            sellCost: this.sellCost,
            coefficient: this.coefficient,
            interest: this.interest,
            supplierProductId: this.supplierProductId,
        }
        
        return result;
    }
}

export class RateCodeSlotService extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.rateCodeId = data.rateCodeId || undefined;
        this.rateCodeProductId = data.rateCodeProductId || undefined;
        this.serviceId = data.serviceId ?? undefined;
        this.sessions = data.sessions || [];
    }

    export() {
        return {
            id: this.id,
            rateCodeId: this.rateCodeId,
            rateCodeProductId: this.rateCodeProductId,
            serviceId: this.serviceId,
            translations: this.translations,
        }
    }
}

export class RateCodeSchedule extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data?.id || undefined;
        this.lengOfStay = data?.lengthOfStay || 0;
        this.rateCodeId = data?.rateCodeId || undefined;
        this.code = data?.code || undefined;
        this.name = data?.name || undefined;
        this.adult = data?.adult || 0;
        this.child = data?.child || 0;
        this.room = data?.room || undefined;
        this.rateCodePlans = data?.rateCodePlans || [];
        // adult: 3
        // child: 2
        // code: "cD01"
        // id: "08da84ea-4bfb-00cf-7414-708e6f738166"
        // lengOfStay: 1
        // name: "cD01"
        // rateCodeId: "14cf747b-4a9b-41ea-b628-c3b31d0b3d84"
    }

    export() {
        const result = {
            id: this.id,
            lengOfStay: this.lengOfStay,
            rateCodeId: this.rateCodeId,
            code: this.code,
            name: this.name,
            adult: this.adult,
            child: this.chil,
            room: this.room,
            rateCodePlans: this.rateCodePlans,
        }
        
        return result;
    }
}

export class Campaign extends BaseModel{
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.name = data.name || undefined;
    }

    export() {
        const result = {
            name: this.name,
        }
        
        return result;
    } 
}